import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice de force de friction - Fisica du frottement";
const DESCRIPTION =
  "Calculatrice de force de friction - Fisica du frottement. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "friction force, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/friction-force-calculator/";

function FrictionForceCalculator() {
  const [coefficient, setCoefficient] = useState("");
  const [normalForce, setNormalForce] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const coefficients = {
    steel_steel: { name: "Acier sur Acier", value: 0.74 },
    rubber_concrete: { name: "Caoutchouc sur Béton", value: 0.9 },
    rubber_asphalt: { name: "Caoutchouc sur Asphalte", value: 0.7 },
    wood_wood: { name: "Bois sur Bois", value: 0.25 },
    metal_wood: { name: "Métal sur Bois", value: 0.2 },
    ice_ice: { name: "Glace sur Glace", value: 0.02 },
    leather_wood: { name: "Cuir sur Bois", value: 0.5 },
  };

  const handleCalculate = () => {
    try {
      if (!coefficient || !normalForce) {
        setError("Veuillez entrer le coefficient de friction et la force normale");
        return;
      }

      const coeffValue = parseFloat(coefficient);
      const normalForceValue = parseFloat(normalForce);

      if (coeffValue < 0 || normalForceValue < 0) {
        setError("Les valeurs doivent être positives");
        return;
      }

      const frictionForce = coeffValue * normalForceValue;
      setResult({
        static: frictionForce.toFixed(4),
        kinetic: (frictionForce * 0.8).toFixed(4),
      });
      setError("");
    } catch (err) {
      setError(err.message);
      setResult(null);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La force de friction est la force qui s'oppose au mouvement observé pour deux surfaces. Elle est calculée en utilisant la formule:
                </p>
                <p>
                  <strong>F_friction = μ × N</strong>
                </p>
                <p>où:</p>
                <ul>
                  <li>F_friction = Force de friction (Newton)</li>
                  <li>μ = Coefficient de friction (sans dimension)</li>
                  <li>N = Force normale (Newton)</li>
                </ul>
                <p>
                  <b>Types de friction:</b>
                  <ul>
                    <li><b>Friction statique:</b> Force qui empêche un objet de se déplacer</li>
                    <li><b>Friction cinétique:</b> Force qui s'oppose au mouvement d'un objet en mouvement</li>
                  </ul>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">Coefficient de friction</label>
                      <select
                        value={coefficient}
                        onChange={(e) => setCoefficient(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">-- Choisissez ou entrez une valeur --</option>
                        {Object.entries(coefficients).map(([key, val]) => (
                          <option key={key} value={val.value}>
                            {val.name} (μ = {val.value})
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label ms-2">Ou entrez la valeur personnalisée:</label>
                      <input
                        type="number"
                        value={coefficient}
                        onChange={(e) => setCoefficient(e.target.value)}
                        placeholder="Entrez le coefficient"
                        className="form-control"
                        style={{ width: "75%" }}
                        step="0.01"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label ms-2">Force normale (Newton)</label>
                      <input
                        type="number"
                        value={normalForce}
                        onChange={(e) => setNormalForce(e.target.value)}
                        placeholder="Entrez la force normale"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>

                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultats:</h4>
                      <p>Force de friction statique: {result.static} N</p>
                      <p>Force de friction cinétique: {result.kinetic} N</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}

export default FrictionForceCalculator;
